/** 文献对比首页 */
<template>
  <div class="module-index comparison-index">
    <div
      class="aside-box"
      :class="{
        'aside-box-hidden': !ifShowHistorys,
      }"
    >
      <div class="fit">
        <AsideHistoryList type="COMPARE" @click="goComparisonDetail" />
      </div>
    </div>
    <div
      class="main-box"
      :class="{
        'main-box-expanded': ifShowHistorys,
      }"
    >
      <div
        class="close-aside-arrow"
        @click="closeHistorys"
        v-if="ifShowHistorys && !pageLoading"
      >
        <el-tooltip content="收起" placement="right" effect="dark">
          <i class="iconfont icon-a-Frame1364" />
        </el-tooltip>
      </div>
      <div
        class="open-aside-arrow"
        @click="openHistorys"
        v-if="!ifShowHistorys"
      >
        <el-tooltip content="查看历史记录" placement="right" effect="dark">
          <i class="iconfont icon-a-Frame1364" />
        </el-tooltip>
      </div>
      <div class="content-box introduce-box">
        <div class="main">
          <div class="left">
            <div class="title">文献对比</div>
            <p class="introduce">自定义比较维度 一键文献对比分析</p>
            <p class="desc">
              <i class="iconfont icon-yuandianxiao dot" />
              配置比较项：自主配置文献比较维度
            </p>
            <p class="desc">
              <i class="iconfont icon-yuandianxiao dot" />
              文献对比表：支持二维表格的方式呈现比较效果 支持手动修改表格内容
            </p>
            <p class="desc">
              <i class="iconfont icon-yuandianxiao dot" />
              文献对比历史：支持保留和查看文献对比历史记录
            </p>
            <p class="desc">
              <i class="iconfont icon-yuandianxiao dot" />
              文献对比导出：支持导出文献对比表
            </p>
            <div class="begin-button">
              <el-button type="primary" @click="handleOpenSelectLiteratureDLG">
                开始文献对比
              </el-button>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/imgs/literature/index.png" />
          </div>
        </div>
        <div class="detail">
          <div class="title">特色功能</div>
          <div class="detail-list">
            <div class="detail-item">
              <div class="item-icon"><i class="iconfont icon-zidingyi1" /></div>
              <div class="item-title">配置比较项</div>
              <div class="item-desc">自主配置文献比较维度</div>
            </div>
            <div class="detail-item">
              <div class="item-icon">
                <i class="iconfont icon-biaogeshezhi" />
              </div>
              <div class="item-title">文献对比表</div>
              <div class="item-desc">
                支持二维表格的方式呈现比较效果 支持手动修改表格内容
              </div>
            </div>
            <div class="detail-item">
              <div class="item-icon">
                <i class="iconfont icon-bg-history" />
              </div>
              <div class="item-title">对比历史</div>
              <div class="item-desc">支持保留和查看文献对比历史记录</div>
            </div>
            <div class="detail-item">
              <div class="item-icon"><i class="iconfont icon-daochu2" /></div>
              <div class="item-title">文献对比导出</div>
              <div class="item-desc">支持导出文献对比表</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DialogSelectLiterature
      ref="dialogSelectLiteratureRef"
      @select="handleAddComparison"
    />
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted } from "vue";
import { httpPost } from "@/api/httpService";
import { confirmBox } from "@/utils/messageBox.js";
import { ElMessage } from "element-plus";
import { useRoute, useRouter } from "vue-router";
import AsideHistoryList from "@/components/literature/AsideHistoryList.vue";
import DialogSelectLiterature from "@/components/literature/DialogSelectLiterature.vue";

const router = useRouter();
const route = useRoute();

//前往文献综述
const goComparisonDetail = (row) => {
  router.push({
    name: "CompareDetail",
    params: {
      uid: row.aicomparisonUid,
    },
  });
};
//打开选择文献弹框
const dialogSelectLiteratureRef = ref(null);
const handleOpenSelectLiteratureDLG = () => {
  dialogSelectLiteratureRef.value.openDLG("CHOOSE", {
    uid: null,
    type: "COMPARE",
  });
};
//获取文献对比Uid
const literatureComparisonUid = ref("");
const getAiliteratureComparisonUid = async (idSelectList) => {
  let params = {
    literatureUidList: idSelectList,
  };
  let res = await httpPost("/comparison/v1/aiLiteratureComparison", params);
  if (res.code == 0) {
    literatureComparisonUid.value = res.data.comparisonUid;
  }
};
//新增综述
const handleAddComparison = async (idSelectList) => {
  if (idSelectList.length < 2) {
    ElMessage.warning("请选择至少两篇文献");
  } else {
    await getAiliteratureComparisonUid(idSelectList);
    if (literatureComparisonUid.value) {
      router.push({
        name: "CompareDetail",
        params: {
          uid: literatureComparisonUid.value,
        },
      });
    }
  }
};

//左侧列表是否显示
const ifShowHistorys = ref(true);
const closeHistorys = () => {
  ifShowHistorys.value = false;
};
const openHistorys = () => {
  ifShowHistorys.value = true;
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/module/module-index.scss";
.main-box {
  padding: 16px;
}
</style>
